import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const useApplyForJobPost = (): any => {
  const { isLoading, status, send } = useRequest({
    url: '/api/v1/application',
    method: ApiMethodsEnum.Post,
    sendOnStart: false,
    body: {},
  });

  const applyForJobPost = (body: any, successFunction: any) => {
    send(body).then((res) => {
      successFunction(res?.chatId);
    });
  };

  return {
    isLoading,
    applyForJobPost,
    status,
  };
};
